
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./BestAtStores.css";
import DealImage from "./DealImage";

const BestAtStoreSection = ({ store }) => {
  const navigate = useNavigate();
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDeals = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}website/deals?store_id=${store._id}&type=normal&limit=3`
        );
        if (data?.success) setDeals(data.data || []);
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };
    fetchDeals();
  }, [store._id]);

  if (loading || deals.length === 0) return null;

  const goToDeal = (slug) => navigate(`/deal/${slug}`);

  return (
    <div className="container best-at-section">
      <div className="section-title best-at-header">
        <h2 className="title best-at-title">Best at {store?.name}</h2>
      </div>

      <div className="deal-grid">
        {deals.map((deal) => (
          <div className="deal-item" key={deal._id}>
            <div className="deal-card" onClick={() => goToDeal(deal.slug)}>
              <DealImage file={deal.image} alt={deal.title} className="deal-card-img" />

              <div className="deal-card-shade" />
              {deal.store_id?.logo && (
                <DealImage
                  file={deal.store_id.logo}
                  alt={deal.store_id.name}
                  className="deal-card-logo"
                  hideOnError
                />
              )}

              {deal.offer_percent > 0 && (
                <span className="badge bg-danger deal-card-badge">
                  -{deal.offer_percent}%
                </span>
              )}

              <div className="deal-card-footer">
                <div className="deal-card-info">
                  {deal.price ? (
                    <div className="deal-card-pricebox">
                      <span className="deal-card-price">₹{deal.price}</span>
                      {deal.mrp && (
                        <span className="deal-card-mrp">₹{deal.mrp}</span>
                      )}
                    </div>
                  ) : (
                    deal.cashback_text && (
                      <span className="deal-card-cashback">
                        {deal.cashback_text}
                      </span>
                    )
                  )}
                </div>

                <button
                  type="button"
                  className="deal-card-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    goToDeal(deal.slug);
                  }}
                >
                  Grab Deal →
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="best-at-footer">
        <button
          type="button"
          className="btn best-at-btn"
          onClick={() =>
            navigate(
              `/deals-listing?store=${store._id}&storeName=${encodeURIComponent(store.name)}`
            )
          }
        >
          View All Products
        </button>
      </div>
    </div>
  );
};

export default BestAtStoreSection;